import { useEffect, useMemo, useState } from 'react'
import NumberFormat from 'react-number-format'
import { useDispatch, useSelector } from 'react-redux'
import { Bounce, toast } from 'react-toastify'
import { addEmployee, clearState, updateEmployee } from 'src/slices/employee'
import Button from '../atoms/Button'
import Checkbox from '../atoms/Checkbox'
import InputWrap from '../molecules/InputWrap'
import css from './EmployeeModal.module.scss'
import GlobalModal from './GlobalModal'

import { defaultPermissions, handleStatus } from '../../slices/utils'
import Select from 'react-select'
import { motion } from 'framer-motion'
import colors from 'src/styles/jscolors.module.scss'
import Pill from '../atoms/Pill'
import utils from '../../slices/utils'
import Switch from '../atoms/Switch'
import { bindActionCreators } from 'redux'
export default function EmployeeModal({
	closeFunction,
	employee,
	setEmployee,
	type = 'create', // create || update
	title = type == 'edit' ? 'Edit Employee' : 'Create Employee',
}) {
	const dispatch = useDispatch()
	const { user } = useSelector(state => state.auth)
	const { status } = useSelector(state => state.employee)
	const { locations } = useSelector(state => state.info)

	const [sectionOpen, setIsSectionOpen] = useState(
		employee.branches?.length > 0
			? employee.branches.reduce(
					(prev, curr) => (
						{
							...prev,
							[curr._id]: {
								Dashboard: false,
								Inventory: false,
								Store: false,
								Edit: false,
								Create: false,
								Delete: false,
								Approve: false,
							},
						},
						{}
					)
			  )
			: {}
	)

	const [pages, setPages] = useState([
		{
			label: 'Dashboard',
			values: [
				{ label: 'Orders', value: 'orders' },
				{ label: 'Analytics', value: 'analytics' },
			],
		},

		{
			label: 'Inventory',
			values: [
				{ label: 'Items', value: 'items' },
				{ label: 'Offers', value: 'offers' },
				{ label: 'Pending Items', value: 'pendingItems' },
				{ label: 'Pending Offers', value: 'pendingOffers' },
				// { label: 'Categories', value: 'categories' },
			],
		},

		{
			label: 'Store',
			isOpen: false,
			values: [
				{ label: 'Banking', value: 'banking' },
				{ label: 'POS', value: 'pos' },
				// { label: 'Employees', value: 'employees' },
				{ label: 'Charities', value: 'charities' },
				{ label: 'Store Info', value: 'store_info' },
			],
		},
	])
	const [permissions, setPermissions] = useState([
		{
			label: 'Edit',
			value: 'update',
			isOpen: false,

			values: [
				{ label: 'Items', value: 'items' },
				{ label: 'Offers', value: 'offers' },
				{ label: 'Pending Items', value: 'pendingItems' },
				{ label: 'Pending Offers', value: 'pendingOffers' },
				{ label: 'Orders', value: 'orders' },

				// { label: 'Employees', value: 'employees' },
				{ label: 'Charities', value: 'charities' },
				// { label: 'Categories', value: 'categories' },
				{ label: 'Store Info', value: 'store_info' },
			],
		},

		{
			label: 'Create',
			value: 'create',
			isOpen: false,
			values: [
				{ label: 'Items', value: 'items' },
				{ label: 'Offers', value: 'offers' },
				// { label: 'Employees', value: 'employees' },
				// { label: 'Charities', value: 'charities' },
				// { label: 'Categories', value: 'categories' },
			],
		},

		{
			label: 'Delete',
			value: 'delete',
			isOpen: false,
			values: [
				{ label: 'Items', value: 'items' },
				{ label: 'Offers', value: 'offers' },
				// { label: 'Pending Items', value: 'pendingItems' },
				// { label: 'Pending Offers', value: 'pendingOffers' },
				// { label: 'Employees', value: 'employees' },
				// { label: 'Categories', value: 'categories' },
			],
		},
		{
			label: 'Approve',
			value: 'approve',
			isOpen: false,
			values: [
				{ label: 'Items', value: 'items' },
				{ label: 'Offers', value: 'offers' },
			],
		},
	])

	const updateField = (field, data) => {
		setEmployee({ ...employee, [field]: data })
	}

	useEffect(
		() =>
			handleStatus(status.addEmployee, () => dispatch(clearState(status.addEmployee)), {
				isSuccess: { callback: () => closeFunction() },
			}),

		[status.addEmployee]
	)
	useEffect(
		() =>
			handleStatus(status.updateEmployee, () => dispatch(clearState(status.updateEmployee)), {
				// isSuccess: { callback: () => closeFunction() },
			}),
		[status.updateEmployee]
	)
	const validate = employeeCredentials => {
		if (!employeeCredentials.firstName) {
			toast.warning(`"First Name" is a required field`)
			return null
		}
		if (!employeeCredentials.lastName) {
			toast.warning(`"Last Name" is a required field`)
			return null
		}
		if (!employeeCredentials.phone) {
			toast.warning(`"Phone" is a required field`)
			return null
		}
		if (!employeeCredentials.email.value) {
			toast.warning(`"Email" is a required field`)
			return null
		}
		if (!employeeCredentials.branches?.some(({ isDefault }) => isDefault)) {
			toast.warning('Please select a default branch')
			return null
		}
		return employeeCredentials
	}

	const handleSubmit = () => {
		if (validate(employee)) {
			type == 'create'
				? dispatch(
						addEmployee({
							email: employee.email.value,
							firstName: employee.firstName,
							lastName: employee.lastName,
							phone: employee.phone,

							branches: JSON.stringify(employee.branches),
							// adminOnBranches,
						})
				  )
				: dispatch(
						updateEmployee({
							empId: employee._id,
							phone: employee.phone,
							branches: JSON.stringify(employee.branches),
						})
				  )
		}
	}

	const selectAll = branchId => {
		setEmployee({
			...employee,
			branches: employee.branches?.map(branch =>
				branch._id == branchId
					? {
							...branch,
							permissions: utils.defaultPermissions('merchant'),
					  }
					: branch
			),
		})
	}

	const clearAll = branchId => {
		setEmployee({
			...employee,
			branches: employee.branches?.map(branch =>
				branch._id == branchId
					? {
							...branch,
							permissions: {
								read: [],
								update: [],
								create: [],
								delete: [],
								approve: [],
							},
					  }
					: branch
			),
		})
	}

	const handleCheckbox = (field, updatedBranch, data, label) => {
		if (!['hasAccess', 'isDefault'].includes(field) && !sectionOpen[updatedBranch._id]?.[label])
			return

		if (field == 'isDefault') {
			const branch = employee.branches?.find(branch => branch._id == updatedBranch._id)
			const tempBranches = employee.branches
				?.map(branch => ({ ...branch, isDefault: false }))
				.filter(branch => branch._id != updatedBranch._id)
			if (!branch) {
				setEmployee({
					...employee,
					branches: [
						...tempBranches,
						{
							_id: updatedBranch._id,
							neighborhood: updatedBranch.neighborhood,
							isDefault: true,

							permissions: {
								read: [],
								update: [],
								create: [],
								delete: [],
								approve: [],
							},
						},
					],
				})
				return
			}
			if (branch.isDefault) {
				setEmployee({
					...employee,
					branches: [...tempBranches, { ...branch, isDefault: false }],
				})
				return
			}
			if (tempBranches.length != employee.branches?.length) {
				setEmployee({
					...employee,
					branches: [...tempBranches, { ...branch, isDefault: true }],
				})
				return
			}
		}
		if (field == 'hasAccess') {
			const branches = employee.branches?.filter(branch => branch._id != updatedBranch._id)
			if (branches.length != employee.branches?.length) {
				setEmployee({ ...employee, branches })
				return
			} else
				setEmployee({
					...employee,
					branches: [
						...branches,
						{
							_id: updatedBranch._id,
							neighborhood: updatedBranch.neighborhood,
							isDefault: employee.branches?.length == 0,

							permissions: utils.defaultPermissions('employee'),
						},
					],
				})
			return
		} else {
			let branch = employee.branches?.find(branch => branch._id == updatedBranch._id)
			branch = { ...branch, permissions: { ...branch.permissions } }
			const tempBranches = employee.branches?.filter(
				branch => branch._id != updatedBranch._id
			)

			const fieldFiltered = branch.permissions[field].filter(value => value != data)

			if (fieldFiltered.length != branch.permissions[field].length) {
				branch.permissions[field] = fieldFiltered
				if (field == 'read') {
					branch.permissions.update = branch.permissions.update.filter(
						value => value != data
					)
					branch.permissions.create = branch.permissions.create.filter(
						value => value != data
					)
					branch.permissions.delete = branch.permissions.delete.filter(
						value => value != data
					)
					branch.permissions.approve = branch.permissions.approve.filter(
						value => value != data
					)
				}
				if (field == 'update') {
					branch.permissions.create = branch.permissions.create.filter(
						value => value != data
					)
					branch.permissions.delete = branch.permissions.delete.filter(
						value => value != data
					)
					branch.permissions.approve = branch.permissions.approve.filter(
						value => value != data
					)
				}

				if (['create', 'delete'].includes(field)) {
					branch.permissions.approve = branch.permissions.approve.filter(
						value => value != data
					)
				}

				setEmployee({
					...employee,
					branches: [...tempBranches, branch],
				})
				return
			} else {
				branch.permissions[field] = [...branch.permissions[field], data]

				if (['create', 'delete'].includes(field)) {
					if (!branch.permissions.update.includes(data))
						branch.permissions.update = [...branch.permissions.update, data]
					branch.permissions.read = [...branch.permissions.read, data]
				}
				if (field == 'update') {
					if (!branch.permissions.update.includes(field))
						branch.permissions.read = [...branch.permissions.read, data]
				}
				if (field == 'approve') {
					if (!branch.permissions.update.includes(field))
						branch.permissions.update = [...branch.permissions.update, data]
				}

				setEmployee({
					...employee,
					branches: [...tempBranches, branch],
				})
			}
		}
	}

	const hasBranchAccess = currBranch =>
		employee.branches?.some(branch => branch._id == currBranch._id) === true

	return (
		<GlobalModal
			closeFunction={() => {
				closeFunction()
			}}
			title={title}
			buttons={
				<>
					<Button
						label='Cancel'
						variant='tertiary'
						color='gray'
						action={closeFunction}
					/>
					<Button
						label={type == 'create' ? 'Create' : 'Save Changes'}
						color={'green'}
						action={handleSubmit}
					/>
				</>
			}>
			<div className={css['content']}>
				{/* change image upload */}
				{/* <InputWrap
          label="Image"
          component={<input type="file" accept="image/png, image/jpeg" />}
        /> */}
				<div className={css['employee-info']}>
					<InputWrap
						label='Email'
						component={
							<input
								value={employee.email.value}
								onChange={e =>
									setEmployee({
										...employee,
										email: { value: e.target.value },
									})
								}
								disabled={employee._id}
							/>
						}
					/>
					<InputWrap
						label='First Name'
						component={
							<input
								value={employee.firstName}
								onChange={e => updateField('firstName', e.target.value)}
								disabled={employee._id}
							/>
						}
					/>
					<InputWrap
						label='Last Name'
						component={
							<input
								value={employee.lastName}
								onChange={e => updateField('lastName', e.target.value)}
								disabled={employee._id}
							/>
						}
					/>

					<InputWrap
						label='Phone'
						component={
							<NumberFormat
								allowEmptyFormatting
								mask='_'
								format='+1 (###) ###-####'
								type='tel'
								value={employee.phone}
								onChange={e => updateField('phone', e.target.value)}
							/>
						}
					/>
				</div>

				<div className={css['branches']}>
					{locations.map(currBranch => {
						return (
							<div className={css['branch']}>
								<div className={css['branch-name']}>
									<p>
										{currBranch.businessName} — {currBranch.neighborhood}
									</p>

									<Button
										// key={currentOption.label}
										size='s'
										label={
											employee.branches?.some(
												branch =>
													branch._id == currBranch._id && branch.isDefault
											) === true
												? 'Default Branch'
												: 'Set as Default'
										}
										variant={
											employee.branches?.some(
												branch =>
													branch._id == currBranch._id && branch.isDefault
											) === true
												? 'primary'
												: 'tertiary'
										}
										color={
											employee.branches?.some(
												branch =>
													branch._id == currBranch._id && branch.isDefault
											) === true
												? 'emerald'
												: 'emerald'
										}
										action={e =>
											handleCheckbox(
												'isDefault',
												currBranch,
												e.target.checked
											)
										}
									/>

									<div className={css['header-wrapper']}>
										{hasBranchAccess(currBranch) && (
											<>
												<Button
													label={'Select All'}
													action={() => selectAll(currBranch._id)}
													iconLeft={'fad fa-ballot-check'}
													color={
														JSON.stringify(
															employee.branches?.find(
																branch =>
																	branch._id == currBranch._id
															).permissions
														) ==
														JSON.stringify(
															utils.defaultPermissions('merchant')
														)
															? 'gray'
															: 'blue'
													}
													variant={'secondary'}
													size={'s'}
													disabled={
														JSON.stringify(
															employee.branches?.find(
																branch =>
																	branch._id == currBranch._id
															).permissions
														) ==
														JSON.stringify(
															utils.defaultPermissions('merchant')
														)
													}
													change
												/>
												<Button
													label={'Clear'}
													action={() => clearAll(currBranch._id)}
													iconLeft={'fad fa-trash-alt'}
													color={
														Object.values(
															employee.branches?.find(
																branch =>
																	branch._id == currBranch._id
															).permissions
														).every(permArray => permArray.length == 0)
															? 'gray'
															: 'red'
													}
													variant={'secondary'}
													size={'s'}
													disabled={Object.values(
														employee.branches?.find(
															branch => branch._id == currBranch._id
														).permissions
													).every(permArray => permArray.length == 0)}
												/>
											</>
										)}
										<InputWrap
											component={
												<Switch
													action={e =>
														handleCheckbox(
															'hasAccess',
															currBranch,
															e.target.checked
														)
													}
													isActive={hasBranchAccess(currBranch)}
												/>
											}
											label='Access'
										/>
									</div>
								</div>

								<motion.div
									className={css['employee-options']}
									animate={{
										opacity: hasBranchAccess(currBranch) ? 1 : 0,
										height: hasBranchAccess(currBranch) ? 'auto' : '0px',
										marginTop: hasBranchAccess(currBranch) ? '12px' : '0px',
									}}
									initial={false}
									transition={{
										ease: 'easeInOut',
										duration: 0.4,
									}}>
									<div className={css['option--page-access']}>
										<p className={css['option-title']}>Page Access</p>
										{pages.map((option, index) => (
											<div
												className={css['box']}
												onClick={() =>
													setIsSectionOpen({
														...sectionOpen,
														[currBranch._id]: {
															[option.label]:
																!sectionOpen[currBranch._id]?.[
																	option.label
																],
														},
													})
												}>
												<div className={css['dropdown-header']}>
													<p>{option.label}</p>
													<i
														className={
															sectionOpen[currBranch._id]?.[
																option.label
															]
																? 'fad fa-chevron-up'
																: 'fad fa-chevron-down'
														}
														onClick={() =>
															setIsSectionOpen({
																...sectionOpen,
																[currBranch._id]: {
																	[option.label]:
																		!sectionOpen[
																			currBranch._id
																		][option.label],
																},
															})
														}
													/>
												</div>

												<motion.div
													className={css['checkboxes']}
													animate={{
														opacity: sectionOpen[currBranch._id]?.[
															option.label
														]
															? 1
															: 0,
														height: sectionOpen[currBranch._id]?.[
															option.label
														]
															? 'auto'
															: '0px',
														marginTop: sectionOpen[currBranch._id]?.[
															option.label
														]
															? '12px'
															: '0px',
													}}
													initial={false}
													transition={{
														ease: 'easeInOut',
														duration: 0.3,
													}}>
													{option.values.map(page => (
														<Checkbox
															label={page.label}
															name={page.label + 'page'}
															key={
																page.value +
																currBranch.businessName +
																'page'
															}
															onChange={e =>
																handleCheckbox(
																	'read',
																	currBranch,
																	page.value,
																	option.label
																)
															}
															onClick={e => {
																// e.preventDefault()
																e.stopPropagation()
															}}
															// Commented this beacuse caused the menu to close when clicking on the label

															// onClick={(
															//     e
															// ) => {
															//     e.stopPropagation();
															//     // e.preventDefault()
															// }}
															value={employee.branches
																?.find(
																	branch =>
																		branch._id == currBranch._id
																)
																?.permissions.read.includes(
																	page.value
																)}
															// defaultChecked={employee?.adminOnBranches?.[index]?.isAdmin}

															// disabled={employee?.branches?.some(
															// 	branch =>
															// 		branch._id != currBranch._id &&
															// 		branch.isDefault
															// )}
														/>
													))}
												</motion.div>
											</div>
										))}
									</div>

									<div className={css['option--permissions']}>
										<p className={css['option-title']}>Permissions</p>
										{permissions.map((option, index) => (
											<div
												className={css['box']}
												onClick={() =>
													setIsSectionOpen({
														...sectionOpen,
														[currBranch._id]: {
															[option.label]:
																!sectionOpen[currBranch._id]?.[
																	option.label
																],
														},
													})
												}>
												<div className={css['dropdown-header']}>
													<p>{option.label}</p>
													<i
														className={
															sectionOpen[currBranch._id]?.[
																option.label
															]
																? 'fad fa-chevron-up'
																: 'fad fa-chevron-down'
														}
														onClick={() =>
															setIsSectionOpen({
																...sectionOpen,
																[currBranch._id]: {
																	[option.label]:
																		!sectionOpen[
																			currBranch._id
																		][option.label],
																},
															})
														}
													/>
												</div>
												<motion.div
													className={css['checkboxes']}
													animate={{
														opacity: sectionOpen[currBranch._id]?.[
															option.label
														]
															? 1
															: 0,
														height: sectionOpen[currBranch._id]?.[
															option.label
														]
															? 'auto'
															: '0px',
														marginTop: sectionOpen[currBranch._id]?.[
															option.label
														]
															? '12px'
															: '0px',
													}}
													initial={false}
													transition={{
														ease: 'easeInOut',
														duration: 0.3,
													}}>
													{option.values.map(field => (
														<Checkbox
															label={field.label}
															name={
																field.label + 'perm' + option.label
															}
															key={
																field.value +
																currBranch.businessName +
																'perm' +
																option.label
															}
															onChange={e =>
																handleCheckbox(
																	option.value,
																	currBranch,
																	field.value,
																	option.label
																)
															}
															onClick={e => {
																// e.preventDefault()
																e.stopPropagation()
															}}
															// onClick={(
															//     e
															// ) => {
															//     e.stopPropagation();
															//     // e.preventDefault()
															// }}
															value={employee.branches
																?.find(
																	branch =>
																		branch._id == currBranch._id
																)
																?.permissions?.[
																	option.value
																].includes(field.value)}
														/>
													))}
												</motion.div>
											</div>
										))}
									</div>
								</motion.div>

								{/* <div className={css['checkboxes']}>
								<Checkbox
									label='Has Access'
									onChange={e =>
										handleCheckbox('hasAccess', currBranch, e.target.checked)
									}
									// defaultChecked={employee?.adminOnBranches?.[index]?.hasAccess}
									// disabled={adminOnBranches?.[index]?.isAdmin}
									value={
										employee.branches?.some(
											branch => branch._id == currBranch._id
										) === true
									}
									key={'giveaccess' + currBranch.businessName}
								/>

								<Checkbox
									label='Is Default'
									onChange={e =>
										handleCheckbox('isDefault', currBranch, e.target.checked)
									}
									value={
										employee.branches?.find(
											branch => branch._id == currBranch._id
										)?.isDefault === true
									}
									// defaultChecked={employee?.adminOnBranches?.[index]?.isAdmin}
									key={'isDefault' + currBranch.businessName}
									disabled={employee?.branches?.some(
										branch => branch._id != currBranch._id && branch.isDefault
									)}
								/>

								<Checkbox
									label='Is Admin'
									onChange={e =>
										handleCheckbox('isAdmin', currBranch, e.target.checked)
									}
									value={
										employee.branches?.find(
											branch => branch._id == currBranch._id
										)?.isAdmin === true
									}
									// defaultChecked={employee?.adminOnBranches?.[index]?.isAdmin}
									key={'makeadmin' + currBranch.businessName}
								/>
							</div> */}
							</div>
						)
					})}
				</div>
			</div>
		</GlobalModal>
	)
}
